export enum HotspotLayoutEnum {
  PLUS = 'plus',
  NUMBER = 'number',
  LETTER = 'letter'
}
